import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PageHead from "@/components/feature/PageHead";

const COMPANY_NAME = "NetBasis International";

const title = "Stratégies d'entrée sur le marché";
const heroImage = "https://net-basis.net/Bilder/dach-market-entry-strategy-target-market-positioning.webp";
const heroAlt = "Une main marque un segment cible rouge dans des cercles superposés pour la stratégie d'entrée.";
const heroClaimLine1 = "En route pour";
const heroClaimLine2 = "votre part de marché !";
const benefitsTitle = "Comment vous profitez de notre expertise en __stratégies d'entrée sur le marché__ :";
const introText = "Des stratégies d'entrée sur le marché stratégiques pour votre succès durable sur le marché DACH. En tant que votre ressource locale expérimentée, nous accompagnons les fabricants étrangers de TIC dans l'identification, le développement et la conception d'options d'entrée optimales dans l'espace économique germanophone.";
const p1Text = "NetBasis International est la ressource locale de ses partenaires pour l'identification, le développement et la conception d'options d'entrée sur de nouveaux marchés. Grâce à des études de marché ciblées et des connaissances approfondies, nous accompagnons l'ensemble du processus de planification de nos fabricants partenaires, les aidons à prendre des décisions stratégiques clés et optimisons leur présence sur le terrain.";
const p1Parts = p1Text.split(COMPANY_NAME);
const bottomClaim = "NetBasis International - drive to excellence with excellent drivers !";

const benefits = [
  "Réalisation d'évaluations détaillées du marché et d'analyses approfondies des marchés cibles",
  "Aide à la décision générale et conseil sur les sous-marchés régionaux dans lesquels il convient d'investir",
  "Soutien complet dans la planification et l'exécution sur la base de l'observation du marché local",
  "Analyse rigoureuse des concurrents potentiels et identification des clients cibles pertinents",
  "Accès direct à nos réseaux de vente établis pour une génération rapide de parts de marché",
  "Garantie de toutes les compétences commerciales nécessaires au succès d'un projet d'entrée sur le marché",
];

export default function StrategiesEntreeMarcheFrPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <PageHead
        title="Stratégies d’Entrée sur le Marché | NetBasis International"
        description="Concepts sur mesure et feuilles de route stratégiques pour le lancement sûr et efficace de votre activité dans la région DACH."
        ogUrl="https://net-basis.net/fr/services/developpement-commercial/strategies-entree-marche"
      />
      <Header />

      <main className="flex-1 pt-20 md:pt-24">
        {/* Hero image */}
        <section className="w-full bg-white py-4 md:py-6 lg:py-8">
          <div className="w-full max-w-[1100px] mx-auto">
            <div className="relative w-full h-[320px] md:h-[420px] lg:h-[500px] overflow-hidden">
              <img loading="lazy"
                src={heroImage}
                alt={heroAlt}
                title={title}
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>

              <div className="absolute inset-0 z-20 flex items-start justify-center pt-[14%] md:pt-[10%] lg:pt-[9%] pointer-events-none">
                <p
                  className="mes-hero-lh-15 markteintritt-hero-text-slide text-3xl md:text-4xl lg:text-5xl font-normal text-white drop-shadow-[0_1px_4px_rgba(0,0,0,0.6)] text-center"
                  style={{ fontFamily: '"Open Sans", sans-serif' }}
                >
                  <span className="block md:hidden">{heroClaimLine1}</span>
                  <span className="block md:hidden">{heroClaimLine2}</span>
                  <span className="hidden md:block">{heroClaimLine1} {heroClaimLine2}</span>
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Content */}
        <section className="py-6 md:py-8 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto">
            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
              {title}
            </h2>

            <h1 className="font-semibold text-foreground-950 leading-relaxed text-sm md:text-base mb-4">
              {introText}
            </h1>

            <div className="space-y-4 text-foreground-950 leading-relaxed text-sm md:text-base">
              <p>
                {p1Parts.map((part, i) => (
                  <span key={i}>
                    {part}
                    {i < p1Parts.length - 1 && (
                      <strong className="text-primary-600">{COMPANY_NAME}</strong>
                    )}
                  </span>
                ))}
              </p>
            </div>

            {/* Green heading with italic word */}
            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mt-8 md:mt-10 mb-5 md:mb-7">
              {benefitsTitle.split("__").map((part, i) =>
                i % 2 === 1 ? <em key={i}>{part}</em> : part
              )}
            </h2>

            {/* Benefits with green checkmarks */}
            <div className="space-y-1.5 md:space-y-2 text-foreground-950 leading-relaxed text-sm md:text-base">
              {benefits.map((benefit, idx) => (
                <div key={idx} className="flex items-start gap-2 md:gap-3">
                  <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-primary-600 text-base md:text-lg"></i>
                  </div>
                  <p>{benefit}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Bottom claim */}
        <section className="py-6 md:py-10 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto text-center">
            <p className="font-heading text-lg md:text-xl font-bold text-primary-600">
              {bottomClaim}
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}